import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { z } from "zod";

export const duplicateShipments = {
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({ newGroups: z.array(FulfillmentGroupDataSchema) }),
};
